import {
    Dialog,
    ScreenMessagePanelContainer,
    Label,
    ButtonLight,
    ButtonStandard,
    ComboBox,
    formatMessage,
} from 'cw-ui-core';
import css from './AuthenticationMethodDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React, { useState } from 'react';
import cx from 'classnames';

export const AUTHENTICATION_METHOD_USER_DIALOG = 'AUTHENTICATION_METHOD_USER_DIALOG';

const AuthenticationMethodDialog = ({ usersCount = 0, setValueOnPath, onCancel, onApply, loginProvidersList }) => {
    const [selectedAuthMethod, setAuthMethodValue] = useState('');
    const setAuthMethod = filter => {
        setAuthMethodValue(filter.id);
        setValueOnPath('authMehodScheme', filter.scheme);
    };

    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="apply"
            automationName="apply"
            className={css.applyButton}
            value={formatMessage(Locale.apply)}
            onClick={onApply}
            disabled={!selectedAuthMethod}
        />,
    ];

    return (
        <Dialog
            dialogId={AUTHENTICATION_METHOD_USER_DIALOG}
            header={formatMessage(Locale.setAuthMethodDialogHeader)}
            buttons={dialogButtons}>
            <div className={cx(css.wrap, layoutCss.podCol)}>
                <ScreenMessagePanelContainer
                    className={css.screenMessage}
                    screenKey={AUTHENTICATION_METHOD_USER_DIALOG}
                />
                <Label value={formatMessage(Locale.authMethodConfirmation)} />
                <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
                <ComboBox
                    cwId="contactTimeFilterCombo"
                    automationName="contactTimeFilterCombo"
                    className={css.contactDropDown}
                    items={loginProvidersList}
                    expandOnClick
                    readOnly
                    value={selectedAuthMethod}
                    onChange={filter => setAuthMethod(filter)}
                    placeholder={formatMessage(Locale.selectMethod)}
                />
            </div>
        </Dialog>
    );
};

export default AuthenticationMethodDialog;
